
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './Page/Home/Home';
import Login from './Page/Login/Login';
import Register from './Page/Register/Register';
import Header from './Page/Header/Header';
import Inventory from './Page/Inventory/Inventory';
import About from './Page/About/About';
import RequireAuth from './Page/RequireAuth/RequireAuth';
import AddCar from './Page/AddCar/AddCar';
import ManageCar from './Page/ManageCar/ManageCar';
import MyCar from './Page/MyCar/MyCar';
import CheckOut from './Page/CheckOut/CheckOut';
import NotFound from './Page/NotFound/NotFound';
import SectionOne from './Page/SectionOne/SectionOne';
import SectionTwo from './Page/SectionTwo/SectionTwo';
import Footer from './Page/Footer/Footer';

function App() {
  return (
    <div className="">
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/login' element={<Login></Login>}></Route>
        <Route path='/myCar' element={<MyCar></MyCar>}></Route>
        <Route path='/about' element={<About></About>}></Route>
        <Route path='/addCar' element={<AddCar></AddCar>}></Route>
        <Route path='/checkOut' element={<CheckOut></CheckOut>}></Route>
        <Route path='/manageCar' element={<ManageCar></ManageCar>}></Route>
        <Route path='/sectionOne' element={<SectionOne></SectionOne>}></Route>
        <Route path='/sectionTwo' element={<SectionTwo></SectionTwo>}></Route>
        <Route path='/inventory/:inventoryId' element={
          <RequireAuth>
            <Inventory></Inventory>
          </RequireAuth>
        }>
        </Route>
        <Route path='/register' element={<Register></Register>}></Route>
        <Route path='*' element={<NotFound></NotFound>}></Route>
      </Routes>
      <Footer></Footer>
    </div >
  );
}

export default App;
